module.exports = __webpack_public_path__ + "static/media/marca-alelo.83139db9.png";